import {Component, OnInit} from '@angular/core';
import {ScheduleService} from '../../services/ScheduleService';
import {FormsModule} from '@angular/forms';
import {Checkbox} from 'primeng/checkbox';
import {InputText} from 'primeng/inputtext';
import {NgSelectComponent} from '@ng-select/ng-select';
import {TimePickerComponent} from '../../components/time-picker';
import {Popover} from 'primeng/popover';
import {ILoadedUser, SystemService} from '../../services/SystemService';
import {AssignmentService} from '../../services/AssignmentService';

declare var Yii: any;

@Component({
  selector: 'ng-schedule-overdue',
  templateUrl: './overdue.html',
  imports: [FormsModule, Checkbox, InputText, NgSelectComponent, TimePickerComponent, Popover]
})
export class AssignmentsScheduleOverdueComponent implements OnInit {
  public Yii = Yii;

  public dueTimeString = "00:00"

  public users: ILoadedUser[] = []
  public assigned_recipients: ILoadedUser[] = []

  constructor(
    private sysvc: SystemService,
    public ssvc: ScheduleService,
    private asvc: AssignmentService
  ) {
  }

  ngOnInit(): void {
    const assigned = this.ssvc.settings.overdue.subscribers;
    this.syncDueTime();
    this.sysvc.GetUsers(this.asvc.GetCurrentChainId())
      .then(users => {
        this.users = users;
        this.assigned_recipients = users.filter(m => assigned.find(a => a.id == m.id) != undefined)
      })
  }

  syncDueTime() {
    let v = this.ssvc.settings.overdue.overdue;
    if (v && v.length >= 5) {
      v = v.substring(0, 5);
    }
    this.dueTimeString = v
  }
}
